import { useEntity, useMeta } from '@uswitch/ev-utils/lib/context/selectors'
import { Palette } from '../palette'
import ReadMoreCard from '../trustyle-read-more-card'

const contentfulVariantMapping = {
  'Read More': 'default',
  Cupcard: 'cupcard',
}

const ConnectedReadMoreCard = ({ displayText, url, variant, ...props }) => {
  const href = useEntity(url).url
  const homePath = useMeta(['breadcrumbs', 'homePath'], '')

  return (
    <ReadMoreCard
      text={displayText}
      href={href[0] === '/' ? href : `${homePath}/${href}`}
      variant={contentfulVariantMapping[variant]}
      {...props}
    />
  )
}

export default props => (
  <Palette as={ConnectedReadMoreCard} px={{ backgroundColor: 'featureColor' }} {...props} />
)
